import { Env } from '@stencil/core';
// skin-quiz
const getProductsApi = async handlers => {
  const { productRecommendation, brand } = await handlers.getConfig();
  const config = await handlers.getConfig();
  const meta =
    brand.journey_type && brand.journey_type.length > 0 && brand.journey_type !== 'self-care' && brand.journey_type !== 'self-care-sensorial'
      ? {
          type: 'product',
          categories: productRecommendation.categories,
          division: brand.division,
          brandName: brand.brand,
          locale: brand.locale,
          version: brand.version,
          limit: productRecommendation.limit,
          // channel: `profiler${brand.version}`,
          journey_type: brand.journey_type,
          offset: 0,
        }
      : {
          type: 'product',
          categories: productRecommendation.categories,
          division: brand.division,
          brandName: brand.brand,
          locale: brand.locale,
          version: brand.version,
          channel: brand.channel,
          limit: productRecommendation.limit,
          offset: 0,
        };

  const quizData = await handlers.getQuizPayloadForML();
  let updatedData = JSON.parse(JSON.stringify(quizData));
  updatedData.map(item => {
    item.answers.map(elem => {
      delete elem.surveyQuestionId;
    });
    return item;
  });
  const assessmentResults = {
    quiz: updatedData,
  };

  const result = await handlers.recommendationService.getRecommendedProducts(
    assessmentResults,
    `${Env.AIBA_SERVICES_BASE_URL}${Env[config.apiConfig.apiEndpoints.recommendations]}`,
    Env.API_KEY_AIBA_SERVICES,
    meta,
  );

  let event = new CustomEvent('event-recommended-products-changed', { detail: result });
  document.dispatchEvent(event);

  await handlers.updateRecommendedProducts(result);
};
export const getArticlesApi = async handlers => {
  const { articleRecommendation, brand } = await handlers.getConfig();
  const config = await handlers.getConfig();
  const meta =
    brand.journey_type && brand.journey_type.length > 0 && brand.journey_type !== 'self-care' && brand.journey_type !== 'self-care-sensorial'
      ? {
          type: 'article',
          categories: articleRecommendation.categories,
          division: brand.division,
          brandName: brand.brand,
          locale: brand.locale,
          version: brand.version,
          limit: articleRecommendation.limit,
          // channel: `profiler${brand.version}`,
          journey_type: brand.journey_type,
          offset: 0,
        }
      : {
          type: 'article',
          categories: articleRecommendation.categories,
          division: brand.division,
          brandName: brand.brand,
          locale: brand.locale,
          version: brand.version,
          limit: articleRecommendation.limit,
          offset: 0,
        };

  const quizData = await handlers.getQuizPayloadForML();
  let updatedData = JSON.parse(JSON.stringify(quizData));
  updatedData.map(item => {
    item.answers.map(elem => {
      delete elem.surveyQuestionId;
    });
    return item;
  });
  const assessmentResults = {
    quiz: updatedData,
  };
  let result = await handlers.recommendationService.getRecommendedArticles(
    assessmentResults,
    `${Env.AIBA_SERVICES_BASE_URL}${Env[config.apiConfig.apiEndpoints.recommendations]}`,
    Env.API_KEY_AIBA_SERVICES,
    meta,
  );
  if (result.data && result.data.data) {
    result.data = result.data.data;
  }
  if (result.data) {
    result = result.data;
  }

  let event = new CustomEvent('event-recommended-articles-changed', { detail: result });
  document.dispatchEvent(event);

  await handlers.updateRecommendedArticles(result);
};
export const handleAnalyzeScreenOnLoad = async () => {
  if (window['AIBA'] && window['AIBA']['utils']) {
    const handlers = window['AIBA']['utils'];
    const { articleRecommendation } = await handlers.getConfig();
    try {
      let [recommendedProduct] = await Promise.all([getProductsApi(handlers)]);
      let recommendedArticle;
      if (articleRecommendation) {
        [recommendedArticle] = await Promise.all([getArticlesApi(handlers)]);
      }
      console.log('recommendedProduct', recommendedProduct);
      console.log('recommendedArticle', recommendedArticle);
    } catch (error) {
      console.error('@AIBA[getArticlesApi]:', error);
    }
  }
};
